import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Disclaimer</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">Disclaimer</h1>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto space-y-6 text-foreground-700">
            <p>The information provided by cssbuybr.help is for general informational and educational purposes only.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">No Affiliation</h2>
            <p>This website is an independent resource and is not affiliated with, endorsed by, or connected to CSSBuy. We do not represent CSSBuy or claim to be an official source.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">No Guarantees</h2>
            <p>We do not guarantee:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Product quality or authenticity</li>
              <li>Seller behavior or reliability</li>
              <li>Shipping times or delivery dates</li>
              <li>Final shipping prices or costs</li>
              <li>Refund outcomes or processes</li>
              <li>Accuracy of third-party information</li>
            </ul>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">External Links</h2>
            <p>Links to kaspreadsheet.com or other external sites are provided for convenience. We are not responsible for their content, policies, or practices.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Verify Before Acting</h2>
            <p>Always verify important information directly through official CSSBuy channels before making purchases, payments, or sharing personal information.</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}